



















import { mapActions, mapGetters } from 'vuex';

import { FilterIdEnum, FilterTypeEnum } from '../../enums';

import { Dictionary, Filter, FilterSelectedValues } from '../../models';

import { CONTEXT_CONSTS } from '../../store/context/context.consts';

import { UiButton } from '../keen-ui';
import DateFilterSelector from './date-filter-selector.component.vue';
import RealtimeFilterSelector from './realtime-filter-selector.component.vue';
import RegularFilterSelector from './regular-filter-selector.component.vue';

export default {
  name: 'filters',
  components: {
    UiButton
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      filters: CONTEXT_CONSTS.getters.enabledFilters,
      appliedFiltersCount: CONTEXT_CONSTS.getters.appliedFiltersCount
    }),
    sortedFilters: function (): Filter[] {
      return Object.values((this.filters as Dictionary<Filter>)).sort((filter1: Filter, filter2: Filter) => {
        if ((filter1.config.id === FilterIdEnum.DATE) || (filter1.config.id === FilterIdEnum.REALTIME)) {
          return -1;
        } else if (filter1.config.id === FilterIdEnum.COMPARE) {
          if (filter2.config.id !== FilterIdEnum.DATE) {
            return -1;
          }
        }
        return 0;
      });
    },
    clearActionAvailable: function (): boolean {
      return Object.values(this.filters).some((filter: Filter) => !filter.config.mandatory);
    }
  },
  props: {
    displayAsBar: Boolean
  },
  methods: {
    ...mapActions(CONTEXT_CONSTS.moduleName, {
      setFiltersSelectedValues: CONTEXT_CONSTS.actions.setFiltersSelectedValues,
      clearFilters: CONTEXT_CONSTS.actions.clearFilters
    }),
    getFilterSelectorComponent: function (filter: Filter) {
      return {
        [FilterTypeEnum.DATE]: () => DateFilterSelector,
        [FilterTypeEnum.REALTIME]: () => RealtimeFilterSelector,
        [FilterTypeEnum.REGULAR]: () => RegularFilterSelector
      }[filter.config.type]();
    },
    onFilterChange: async function (filter: Filter, selectedValues: FilterSelectedValues) {
      await this.setFiltersSelectedValues({
        [filter.config.id]: selectedValues
      });
      this.$emit('contextChanged');
    },
    onClearClick: async function () {
      await this.clearFilters();
      this.$emit('contextChanged');
    }
  }
};

